// fastest way to clone date
// https://jsperf.com/clone-date-object2
export function cloneDate(date) {
    return new Date(date.getTime());
}
//# sourceMappingURL=clone.js.map


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ngx-bootstrap/chronos/create/clone.js
// module id = ../../../../ngx-bootstrap/chronos/create/clone.js
// module chunks = 8